import {ListViewConfig} from '../../../app/config/model/listview-config.model';
import {AttributeType} from '../../../app/shared/enum/attribute-type.enum';
import Enums from "../../../app/shared/enum/enums";
import Workspace = Enums.Workspace;

export const LIST_VIEW_CONFIG: ListViewConfig = {
  pageSize: 50,
  table: {
    columnMode: 'standard',
    cssClasses: {
      sortAscending: 'esri-icon-up-down-arrows',
      sortDescending: 'esri-icon-up-down-arrows',
      pagerLeftArrow: 'esri-icon-left-triangle-arrow',
      pagerRightArrow: 'esri-icon-right-triangle-arrow',
      pagerPrevious: 'esri-icon-beginning',
      pagerNext: 'esri-icon-end',
    },
    messages: {
      emptyMessage: 'LIST_VIEW.DATATABLE.EMPTY_MESSAGE',
      totalMessage: 'LIST_VIEW.DATATABLE.TOTAL',
    },
    externalPaging: false,
    externalSorting: false,
    reorderable: true,
    scrollbarH: true,
    scrollbarV: false,
    loadingIndicator: true,
    footerHeight: 30,
    headerHeight: 25,
    rowHeight: 50,
    limit_def: 'Maximal Anzahl Seiten, welche noch als klickbare Nummern  angezeigt werden',
    limit: 5,
    count_def: 'Total Anzahl Zeilen',
    count: 3,
    offset: 0,
    sorts: [],
    sortType: 'single',
    selectionType: 'single',
  },
  listTabs: [
    {
      fkArbeitsbereich: Workspace.sbb_eigentumsflaeche,
      tabs: [
        {
          fkLayer: 'parzellen',
          title: 'LIST_VIEW.TABS.TEILPARZELLEN',
          layerId: 1,
          columns: [
            {
              name: 'OBJECTID',
              prop: 'attributes.OBJECTID',
              hidden: false,
              type: AttributeType.id
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.ID',
              prop: 'attributes.ID',
              filter: false,
              multiple: false,
              minWidth: 60,
              type: AttributeType.id
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.OBJEKTNR',
              prop: 'attributes.OBJEKTNR',
              filter: false,
              multiple: false,
              minWidth: 210,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.EGRID',
              prop: 'attributes.EGRID',
              filter: false,
              multiple: false,
              minWidth: 135,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.AOID_TGR',
              prop: 'attributes.AOID_TGR',
              filter: true,
              multiple: false,
              minWidth: 135,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.ANLAGE_NR',
              prop: 'attributes.ANLAGE_NR',
              filter: false,
              multiple: false,
              minWidth: 80,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.FLAECHE_AUSGEGLICHEN',
              prop: 'attributes.FLAECHE_AUSGEGLICHEN',
              filter: false,
              multiple: false,
              roundValue: true,
              minWidth: 100,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.FLAECHE_BERECHNET',
              prop: 'attributes.FLAECHE_BERECHNET',
              filter: false,
              multiple: false,
              float: 1,
              minWidth: 80,
              type: AttributeType.text
            },
            {
              name: 'JSON_CONFIG.DETAIL_VIEW.IMMOBILIEN.EIGENTUEMER_TYP',
              prop: 'attributes.EIGENTUEMER_TYP',
              filter: false,
              multiple: true,
              minWidth: 120,
              type: AttributeType.domain
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.NUTZUNG_TYP',
              prop: 'attributes.NUTZUNG_TYP',
              filter: true,
              multiple: true,
              minWidth: 180,
              type: AttributeType.domain
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.PARZNR',
              prop: 'attributes.PARZNR',
              filter: false,
              multiple: false,
              minWidth: 110,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.GEMEINDE',
              prop: 'attributes.GEMEINDE',
              filter: true,
              multiple: false,
              minWidth: 150,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.BFS_NUMMER',
              prop: 'attributes.BFS_NUMMER',
              filter: false,
              multiple: false,
              minWidth: 60,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.LINIE',
              prop: 'attributes.LINIE',
              filter: true,
              multiple: false,
              minWidth: 50,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.EIGENTUMSART',
              prop: 'attributes.EIGENTUMSART',
              filter: true,
              multiple: false,
              minWidth: 140,
              type: AttributeType.domain
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.BUCHUNGSKREIS',
              prop: 'attributes.BUCHUNGSKREIS',
              filter: true,
              multiple: false,
              minWidth: 120,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.MITEIGENTUM_ANTEIL_M2',
              prop: 'attributes.MITEIGENTUM_ANTEIL_M2',
              filter: false,
              multiple: false,
              minWidth: 140,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.TEILPARTZELLEN.MITEIGENTUM_ANTEIL_PROZENT',
              prop: 'attributes.MITEIGENTUM_ANTEIL_PROZENT',
              filter: false,
              multiple: false,
              minWidth: 140,
              type: AttributeType.number
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: 'verkaufsobjekte',
      tabs: [
        {
          fkLayer: 'verkaufsobjekte',
          layerId: 9,
          title: 'LIST_VIEW.TABS.VERKAUFSOBJEKTE',
          columns: [
            {
              name: 'OBJECTID',
              prop: 'attributes.OBJECTID',
              hidden: false,
              type: AttributeType.id
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.ID',
              prop: 'attributes.ID',
              filter: false,
              multiple: false,
              minWidth: 110,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.ID_SAP',
              prop: 'attributes.ID_SAP',
              filter: false,
              multiple: false,
              minWidth: 110,
              type: AttributeType.number
            },

            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.REFX_VERTRAGSNUMMER',
              prop: 'attributes.REFX_VERTRAGSNUMMER',
              filter: true,
              width: 200,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.EGRIS_EGRID',
              prop: 'attributes.EGRIS_EGRID',
              filter: true,
              multiple: false,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.LINIE',
              prop: 'attributes.LINIE',
              filter: true,
              minWidth: 110,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.KM_ANF',
              prop: 'attributes.KM_ANF',
              filter: true,
              multiple: false,
              minWidth: 110,
              float: 3,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.KM_ENDE',
              prop: 'attributes.KM_ENDE',
              filter: true,
              multiple: false,
              minWidth: 110,
              float: 3,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.FLAECHE_BERECHNET',
              prop: 'attributes.FLAECHE_BERECHNET',
              filter: false,
              multiple: false,
              minWidth: 120,
              roundValue: true,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.EASTING',
              prop: 'attributes.EASTING',
              filter: false,
              multiple: false,
              minWidth: 110,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.NORTHING',
              prop: 'attributes.NORTHING',
              filter: false,
              multiple: false,
              minWidth: 110,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.VERKAUFDATUM',
              prop: 'attributes.VERKAUFDATUM',
              filter: true,
              multiple: false,
              minWidth: 140,
              type: AttributeType.date
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.VERKAUFT',
              prop: 'attributes.VERKAUFT',
              filter: true,
              multiple: false,
              minWidth: 110,
              type: AttributeType.boolean
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.VERKAUFSOBJEKTART',
              prop: 'attributes.VERKAUFSOBJEKTART',
              filter: true,
              multiple: false,
              minWidth: 110,
              type: AttributeType.domain
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.BAURECHT_KATEGORIE',
              prop: 'attributes.BAURECHT_KATEGORIE',
              filter: true,
              multiple: false,
              minWidth: 120,
              type: AttributeType.domain
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.BAURECHT_STATUS',
              prop: 'attributes.BAURECHT_STATUS',
              filter: true,
              multiple: false,
              minWidth: 110,
              type: AttributeType.domain
            },
            {
              name: 'LIST_VIEW.VERKAUFSOBJEKTE.IMPORT_DATE',
              prop: 'attributes.IMPORT_DATE',
              filter: false,
              multiple: false,
              minWidth: 140,
              type: AttributeType.date
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: 'areale',
      ignoreMapExtent: true,
      tabs: [
        {
          fkLayer: 'areale_view',
          layerId: 0,
          title: 'LIST_VIEW.TABS.AREALE',
          columns: [
            {
              name: 'OBJECTID',
              prop: 'attributes.OBJECTID',
              hidden: false,
              type: AttributeType.id
            },
            {
              name: 'LIST_VIEW.AREALE.REFX_AOID_AR',
              prop: 'attributes.REFX_AOID_AR',
              filter: true,
              multiple: false,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.AREALE.REFX_BEZEICHNUNG',
              prop: 'attributes.REFX_BEZEICHNUNG',
              filter: true,
              width: 400,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.AREALE.REFX_LAENDERCODE',
              prop: 'attributes.REFX_LAENDERCODE',
              filter: true,
              minWidth: 50,
              type: AttributeType.text
            },
          ],
        },
      ],
    },
    {
      fkArbeitsbereich: 'strategieflaechen',
      tabs: [
        {
          fkLayer: 'strategieflaeche',
          title: 'LIST_VIEW.TABS.STRATEGIEFLAECHE',
          layerId: 6,
          columns: [
            {
              name: 'OBJECTID',
              prop: 'attributes.OBJECTID',
              hidden: false,
              type: AttributeType.id
            },
            {
              name: 'ID',
              prop: 'attributes.ID',
              hidden: false,
              type: AttributeType.id
            },
            {
              name: 'LIST_VIEW.STRATEGIEFLAECHE.BEZEICHNUNG',
              prop: 'attributes.BEZEICHNUNG',
              filter: true,
              multiple: false,
              minWidth: 300,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.STRATEGIEFLAECHE.STRATEGIE',
              prop: 'attributes.STRATEGIE',
              filter: true,
              multiple: false,
              minWidth: 200,
              type: AttributeType.domain
            },
            {
              name: 'LIST_VIEW.STRATEGIEFLAECHE.BEGRUENDUNG_GRSTRAT',
              prop: 'attributes.BEGRUENDUNG_GRSTRAT',
              filter: true,
              multiple: false,
              minWidth: 400,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.STRATEGIEFLAECHE.FLAECHE',
              prop: 'attributes.FLAECHE',
              filter: false,
              multiple: false,
              minWidth: 100,
              roundValue: true,
              type: AttributeType.number
            },
            {
              name: 'LIST_VIEW.STRATEGIEFLAECHE.ZUGEH_EGRID',
              prop: 'attributes.ZUGEH_EGRID',
              filter: true,
              multiple: false,
              minWidth: 400,
              type: AttributeType.text
            },
            {
              name: 'LIST_VIEW.STRATEGIEFLAECHE.LAUFZEIT_BAURECHT',
              prop: 'attributes.LAUFZEIT_BAURECHT',
              filter: false,
              multiple: false,
              minWidth: 140,
              type: AttributeType.date
            },
            {
              name: 'LIST_VIEW.STRATEGIEFLAECHE.MUTATION_DATUM',
              prop: 'attributes.MUTATION_DATUM',
              filter: false,
              multiple: false,
              minWidth: 140,
              type: AttributeType.date
            },
          ],
        },
      ],
    },
  ],
};
